// @ts-nocheck
// ====== Profilo utente + preferenze notifiche/scadenze ======

function renderProfilo() {
  const u = getCurrentUser();
  if (!u) return;
  // Vista lazy: se non è ancora montata nel DOM, esci (renderAll la chiama al boot)
  if (!$('#profileName')) return;
  $('#profileAvatar').textContent = initials(u.name);
  $('#profileName').textContent = u.name;
  $('#profileEmail').textContent = u.email;
  const badge = $('#profileRoleBadge');
  badge.textContent = roleLabel(u.role);
  badge.className = 'role-badge ' + (u.role === 'admin' ? 'admin' : 'utente');
  renderPrefsControls();
  wirePrefsButtons();
}

function renderPrefsControls() {
  if (typeof getUserPrefs !== 'function') return;
  const prefs = getUserPrefs();
  const browser = document.getElementById('prefBrowserPush');
  if (browser) browser.checked = prefs.browser_push !== false;
  const soglie = document.getElementById('prefScadenzeSoglie');
  if (soglie) soglie.value = (prefs.scadenze_soglie || []).join(', ');

  // F5: soglie del cruscotto Controllo area
  const ac = document.getElementById('prefAreaContractDays');
  if (ac) ac.value = prefs.area_contract_days != null ? prefs.area_contract_days : 30;
  const as = document.getElementById('prefAreaStuckDays');
  if (as) as.value = prefs.area_stuck_days != null ? prefs.area_stuck_days : 14;

  // F5: digest serale opzionale (0-23, vuoto = disattivo)
  ensureDigestControl(prefs);

  const list = document.getElementById('prefNotifList');
  if (list && Array.isArray(globalThis.USER_PREF_CATEGORIES)) {
    list.innerHTML = globalThis.USER_PREF_CATEGORIES.map(
      (c) => `
        <label class="pref-toggle">
          <input type="checkbox" data-cat="${escapeHtml(c.id)}" ${prefs.notif_mute?.includes(c.id) ? '' : 'checked'} />
          <span>${escapeHtml(c.label)} <span class="muted" style="font-size:11px;">(${escapeHtml(c.id)})</span></span>
        </label>`
    ).join('');
  }
}

function ensureDigestControl(prefs) {
  // Inserisce un selettore "Digest giornaliero alle XX:00" nella sezione preferenze.
  const target =
    document.getElementById('prefBrowserPush')?.parentElement?.parentElement ||
    document.getElementById('prefDigestRow')?.parentElement;
  if (!target) return;
  if (document.getElementById('prefDigestHour')) {
    document.getElementById('prefDigestHour').value =
      prefs.daily_digest_hour == null ? '' : String(prefs.daily_digest_hour);
    return;
  }
  const block = document.createElement('div');
  block.className = 'form-field';
  block.id = 'prefDigestRow';
  block.style.cssText = 'margin-top:14px;';
  block.innerHTML = `
    <label for="prefDigestHour" style="font-weight:600;">Digest giornaliero in-app (F5)</label>
    <div style="display:flex;gap:8px;align-items:center;">
      <select id="prefDigestHour" style="max-width:200px;">
        <option value="">— Disattivato —</option>
        ${Array.from({ length: 24 }, (_, h) => `<option value="${h}">Ore ${String(h).padStart(2, '0')}:05</option>`).join('')}
      </select>
      <span class="muted" style="font-size:11px;">Riepilogo di to-do aperti + scadenze 7gg, generato lato server. Nessuna email.</span>
    </div>`;
  target.appendChild(block);
  const sel = block.querySelector('#prefDigestHour');
  sel.value = prefs.daily_digest_hour == null ? '' : String(prefs.daily_digest_hour);
  sel.addEventListener('change', async () => {
    const v = sel.value === '' ? null : parseInt(sel.value, 10);
    if (typeof saveUserPrefs === 'function') {
      await saveUserPrefs({ daily_digest_hour: v });
      toast(
        v == null ? 'Digest disattivato' : `Digest impostato alle ${String(v).padStart(2, '0')}:05`
      );
    }
  });
}

async function onSavePrefs() {
  if (typeof saveUserPrefs !== 'function') return;
  const mutedCats = [];
  document.querySelectorAll('#prefNotifList input[data-cat]').forEach((cb) => {
    if (!cb.checked) mutedCats.push(cb.dataset.cat);
  });
  const browser = document.getElementById('prefBrowserPush')?.checked !== false;
  const sogliaInput = (document.getElementById('prefScadenzeSoglie')?.value || '').trim();
  let soglie = sogliaInput
    .split(',')
    .map((s) => parseInt(s.trim(), 10))
    .filter((n) => Number.isFinite(n) && n >= 0 && n <= 365);
  if (!soglie.length) soglie = [30, 14, 7, 1];
  soglie = [...new Set(soglie)].sort((a, b) => b - a);

  // F5: soglie controllo area
  const acv = parseInt(document.getElementById('prefAreaContractDays')?.value, 10);
  const asv = parseInt(document.getElementById('prefAreaStuckDays')?.value, 10);

  await saveUserPrefs({
    browser_push: browser,
    notif_mute: mutedCats,
    scadenze_soglie: soglie,
    area_contract_days: Number.isFinite(acv) && acv > 0 ? acv : 30,
    area_stuck_days: Number.isFinite(asv) && asv > 0 ? asv : 14
  });
  toast('Preferenze salvate');
  renderPrefsControls();
  // Riflette subito le nuove soglie su cruscotto e dashboard
  if (typeof renderControlloArea === 'function' && document.getElementById('controlloRoot'))
    renderControlloArea('controlloRoot');
  if (typeof renderDashboard === 'function') renderDashboard();
}

async function onResetPrefs() {
  const ok =
    typeof confirmAction === 'function'
      ? await confirmAction({
          level: 'info',
          title: 'Ripristina default',
          message:
            'Vuoi ripristinare le preferenze ai valori di default? Tutte le tue scelte verranno sovrascritte.',
          confirmText: 'Ripristina'
        })
      : confirm('Ripristina preferenze ai default?');
  if (!ok) return;
  if (typeof saveUserPrefs !== 'function') return;
  await saveUserPrefs({
    browser_push: true,
    notif_mute: [],
    scadenze_soglie: [30, 14, 7, 1]
  });
  toast('Preferenze ripristinate');
  renderPrefsControls();
}

// Wiring idempotente dei pulsanti preferenze. La vista "impostazioni" è lazy:
// i bottoni esistono solo dopo il mount, quindi leghiamo i listener qui e lo
// richiamiamo da renderProfilo() (eseguito dal router dopo l'iniezione).
let _prefsWired = false;
function wirePrefsButtons() {
  if (_prefsWired) return;
  const save = document.getElementById('btnSavePrefs');
  if (!save) return; // vista non ancora montata
  save.addEventListener('click', onSavePrefs);
  document.getElementById('btnResetPrefs')?.addEventListener('click', onResetPrefs);
  document.getElementById('btnSaveAreaPrefs')?.addEventListener('click', onSavePrefs);
  _prefsWired = true;
}
// Compat: se la vista fosse inline al load, lega subito; altrimenti no-op.
document.addEventListener('DOMContentLoaded', wirePrefsButtons);

Object.assign(globalThis, { renderProfilo, renderPrefsControls });
export {};
